import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import InvoiceTable from "./InvoiceTable";

const InvoiceListPage = () => {
  return (
    <NavHeightAdjust>
      <InvoiceTable />
    </NavHeightAdjust>
  );
};

export default InvoiceListPage;
